import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { Text } from '@mxenabled/mxui'

import { useScreenSize } from '../../../hooks'
import { CategoryColors } from '../../../../core/constants'
import { useCategoryStore } from '../../../context'

interface CustomLegendProps {
  sx?: object
  categoryGuids: { guid: string; top_level_guid: string }[]
  hoveredLegend: string | null
  legendRef?: (instance: HTMLElement | null) => void
  onHoverLegend: (label: string | null) => void
  onClickLegend: (label: string | null) => void
}

export const CustomLegend: React.FC<CustomLegendProps> = ({
  sx,
  categoryGuids,
  hoveredLegend,
  legendRef,
  onHoverLegend,
  onClickLegend,
}) => {
  const { isMobile } = useScreenSize()
  const { getCategoryName } = useCategoryStore()

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      gap={isMobile ? 2 : 6}
      justifyContent="start"
      ref={legendRef}
      sx={sx}
    >
      {categoryGuids.map(({ guid, top_level_guid }) => {
        const isHovered = hoveredLegend === guid
        const categoryColor = CategoryColors[guid]
        const topLevelCategoryColor = CategoryColors[top_level_guid]
        const baseBackground = categoryColor ?? topLevelCategoryColor ?? CategoryColors.default
        const transparentBackground = baseBackground + '33'
        const hoveredBackground = isHovered ? baseBackground : transparentBackground
        const backgroundColor = hoveredLegend ? hoveredBackground : baseBackground

        return (
          <Button
            key={guid}
            onClick={() => onClickLegend(guid)}
            onMouseEnter={() => onHoverLegend(guid)}
            onMouseLeave={() => onHoverLegend(null)}
            sx={{
              color: 'text.primary',
              fontWeight: 'normal',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingX: 8,
              paddingY: 4,
              borderRadius: 1,
              opacity: isHovered ? 1 : 0.7,
            }}
          >
            <Box
              sx={{
                width: 16,
                height: 16,
                marginRight: isMobile ? 5 : 10,
                borderRadius: '2px',
                backgroundColor,
              }}
            />
            <Text variant="body1">{getCategoryName(guid)}</Text>
          </Button>
        )
      })}
    </Stack>
  )
}
